import{o as t,p as s}from"./index-36a28185.js";class e{constructor(){this.component=t(),this.svelteDispatch=s()}dispatch(t,s){this.svelteDispatch(t,s),this.component.dispatchEvent&&this.component.dispatchEvent(new CustomEvent(t,{detail:s}))}}export{e as E};
//# sourceMappingURL=EventHandler-1d9fbaf2.js.map
